import React, { useMemo } from "react";
import { Chip } from "@mui/material";
import {
  AnswerReviewDialog,
  normalizeExamAttempt,
} from "@/components/common";

/**
 * ExamResultDialog — thin wrapper for TOEIC mock-exam attempts.
 *
 * Public props (UNCHANGED — preserve all existing call sites):
 *   { open, onClose, examAttempt }
 *
 * Normalizes the existing `examAttempt` payload (no API changes) into the
 * shared `detailedGroups[]` shape and renders the unified
 * <AnswerReviewDialog /> from `@/components/common`.
 */
const ExamResultDialog = ({ open, onClose, examAttempt }) => {
  const detailedGroups = useMemo(
    () => normalizeExamAttempt(examAttempt),
    [examAttempt]
  );

  if (!examAttempt || !examAttempt.exam) return null;

  const examTitle = examAttempt.exam?.title || "Exam";
  const headerChips = [
    <Chip
      key="total"
      label={`Total: ${examAttempt.score || 0}/990`}
      color="secondary"
    />,
    <Chip
      key="listening"
      label={`Listening: ${examAttempt.listeningScore || 0}/495`}
      color="info"
    />,
    <Chip
      key="reading"
      label={`Reading: ${examAttempt.readingScore || 0}/495`}
      color="info"
    />,
  ];

  return (
    <AnswerReviewDialog
      open={open}
      onClose={onClose}
      title={`${examTitle} — Detailed Results`}
      headerChips={headerChips}
      detailedGroups={detailedGroups}
    />
  );
};

export default ExamResultDialog;
